import { NavigationState } from '../modules/navigation/types'
import App from './App'
import Form from '../modules/search/containers/Form'
import Other from './Other'
import '../assets/css/index.css';

import i18n from '../utils/i18n';

i18n.locale = 'da';
let locale: any = window.location.pathname;
locale = locale.split("/");
if (locale && locale[1]) {
  i18n.locale = locale[1];
} else {
  i18n.locale = 'da';
}

const routes: NavigationState = {
  index: 0,
  history: [ 'searchForm' ],
  routes: {
    app: App,
    other: Other,
    searchForm: Form,
  }
}

export default routes;
